import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../app-context/AuthContext";
import Header from "../components/Header";

const Login = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(String(email).toLowerCase());
  };

  const handleLogin = () => {
    if (!validateEmail(email)) {
      setError("Invalid email address");
      return;
    }
    setError("");
    login(email);
    navigate("/");
    window.location.reload();
  };

  return (
    <>
      <Header />
      <div className="container mx-auto">
        <h1 className="text-2xl text-center my-4">Login</h1>
        <div className="flex justify-center">
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="p-2 border border-gray-300 rounded"
          />
          <button
            onClick={handleLogin}
            className="ml-2 p-2 bg-red-500 text-white rounded"
          >
            Login
          </button>
        </div>
        {error && <div className="text-red-500 text-center mt-4">{error}</div>}
      </div>
    </>
  );
};

export default Login;
